import React from "react";
import TableEditable from "../TableEditable";

const FormData = ({ updateData, data }) => {
  return <TableEditable updateData={updateData} type="FORMDATA" data={data} />;
};
export default FormData;
